import './DeliverySelector.scss';
import { useRef, useState, FC, useEffect } from 'react';
import { Icon } from '../../Icon/Icon';
import classNames from 'classnames';
import { useOnClickOutside } from 'usehooks-ts';

type Props = {
	deliveryType: string;
	errorMessage?: string;
	handleChange: (args: string) => void;
};

export const DeliverySelector: FC<Props> = ({
	deliveryType,
	errorMessage,
	handleChange,
}) => {
	const [showOptions, setShowOptions] = useState(false);
	const [selectedDelivery, setSelectedDelivery] = useState({
		handle: '',
		label: 'Vælg levering',
	});
	const [deliveryTypes, setDeliveryTypes] = useState([
		{ handle: '', label: 'Vælg levering' },
		{ handle: 'pickup', label: 'Afhentes i butik' },
		{ handle: 'delivery', label: 'Leveres til adresse' },
	]);

	useEffect(() => {
		deliveryTypes.find((element) => {
			if (element.handle === deliveryType) {
				setSelectedDelivery(element);
			}
		});
	}, [deliveryType]);

	const ref = useRef(null);

	//!temporary Sends everyone back to orders
	const handleDeliverySelected = (handle: string, label: string) => {
		setSelectedDelivery({ handle: handle, label: label });
		handleChange(handle);
	};

	// Hide the popup when clicking outside the popup
	const handleClickOutside = () => {
		setShowOptions(false);
	};

	// Toggle the popup
	const handleOptionsClick = () => {
		setShowOptions(!showOptions);
	};

	// Setup on outside click handler
	useOnClickOutside(ref, handleClickOutside);

	return (
		<div className="deliverySelector-wrapper" ref={ref}>
			{showOptions && (
				<div className="deliverySelector-list">
					{deliveryTypes.map(({ handle, label }) => {
						return (
							<div
								key={handle}
								className={classNames('deliverySelector-list__item', {
									'is-active': handle === selectedDelivery.handle,
								})}
								onClick={() => {
									handleDeliverySelected(handle, label);
									setShowOptions(!showOptions);
								}}
							>
								{label}
							</div>
						);
					})}
				</div>
			)}
			<div className="deliverySelector" onClick={handleOptionsClick}>
				<div className="locationSelector__header">{selectedDelivery.label}</div>
				<div
					className={classNames('deliverySelector__icon', {
						'deliverySelector__icon--active': showOptions,
					})}
				>
					<Icon name="Carret" width={11} />
				</div>
			</div>
			<span className="TextInputError">{errorMessage}</span>
		</div>
	);
};
